import config from '../../config';
import { APICore } from './apiCore';

const api = new APICore();

function getUserApiKeys(userId) {
    const baseUrl = config.USERS_URL;
    return api.get(`${baseUrl}/${userId}/api_keys`);
}

function createUserApiKey(userId) {
    const baseUrl = config.USERS_URL;
    return api.create(`${baseUrl}/${userId}/api_keys`);
}

function deleteUserApiKey(userId, apiKeyId) {
    const baseUrl = config.USERS_URL;
    return api.delete(`${baseUrl}/${userId}/api_keys/${apiKeyId}`);
}

export { getUserApiKeys, createUserApiKey, deleteUserApiKey };
